
import { SnackbarProgrammatic as Snackbar } from 'buefy'
import API from '@/api'

const actions = {
  updateAgencyProfile({ dispatch, commit }, payload) {
    API.myAgency.update(payload)
      .then(({ data: { data } }) => {
        Snackbar.open({
          duration: 5000,
          message: '<span>Успешно</span>Заявка на обновление данных была отправлена.',
          position: 'is-top-right',
          type: 'is-success'
        })

        commit('changeShowAgencyForm', false)
      })
      .catch(({ data: { errors } }) => {
        commit('setAgencyFormErrors', errors)
      })
  },
}

export default actions